import { render, staticRenderFns } from "./SingleChoiceAnswer.vue?vue&type=template&id=126f6251&scoped=true&"
import script from "./SingleChoiceAnswer.vue?vue&type=script&lang=ts&"
export * from "./SingleChoiceAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./SingleChoiceAnswer.vue?vue&type=style&index=0&id=126f6251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f6251",
  null
  
)

export default component.exports